<template>

  <div>
    <div v-if="mostrarFormBusqueda">
      <admin-permisos-form-component :original="datosForm" @_cancelarEditar="cancelarEditar"></admin-permisos-form-component>
    </div>
    <div v-else>
      <aside class="bg-primary bg-gradient rounded-1 p-0 p-sm-1 mt-1">
        <div
            class="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
          <div class="mb-4 mb-xl-0">
            <div class="fs-3 fw-bold text-white">Permisos</div>
            <div class="text-white-50">En ésta sección podrás administrar los permisos</div>
          </div>
          <div class="mb-4 mb-xl-0">
            <div class="row">
              <div class="col">
                <button type="button" class="btn btn-success btn-sm"
                        @click="editar(null)">
                  <FontAwesomeIcon :icon="faPlus()"/>
                  Agregar Permiso
                </button>
              </div>
            </div>
          </div>
        </div>
      </aside>

      <div class="container px-lg-3 px-xl-2 px-xxl-2 mt-2">
        <div class="row ">

          <div class="col-10">
            <div class="input-group">
              <span class="input-group-text">Permiso</span>
              <input v-model="filtros.nombre"
                     style="float: right;"
                     class="form-control"
                     placeholder="Nombre/Código del permiso"
                     @keydown.prevent.enter="obtener()"
              />
              <button type="button" class="input-group-text" style="float: right;" @click="filtros.nombre=null"
                      v-if="filtros.nombre!=null">
                <FontAwesomeIcon :icon="faClose()" title="Restablecer Nombre/Código del permiso"/>
              </button>
            </div>
          </div>
          <div class="col-2">
            <button type="button" class="btn btn-success" style="float: right;" @click="obtener()">
              <FontAwesomeIcon :icon="faSearch()"/>
              Buscar
            </button>
          </div>

        </div>
      </div>

      <div class="container">
        <div class="row m-4">
          <div class="col" align="right">

          </div>
        </div>
        <div class="row">
          <div class="table-responsive" style="height: 200px">
            <table class="table table-striped table-light table-border">
              <thead>
              <tr>
                <th width="10%" class="header" scope="col">ID</th>
                <th width="70%" class="header" scope="col">Permiso</th>
                <th width="20%" class="header" scope="col">Código</th>
                <th width="20%" class="header" scope="col">Acciones</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in datos_tabla" v-bind:key="item.id">
                <th scope="row">{{ item.id }}</th>
                <th scope="row">{{ item.permiso }}</th>
                <th scope="row">{{ item.codigo }}</th>
                <th scope="row">
                  <button class="btn btn-danger m-1"
                          @click="eliminar(item.id)" title="Eliminar">
                    <FontAwesomeIcon :icon="faDesActivar()"/>
                  </button>
                  <button class="btn btn-warning m-1" @click="editar(item)" title="Editar">
                    <FontAwesomeIcon :icon="faEditar()"/>
                  </button>
                </th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

import {inject} from "vue";
import {PermisosService} from "@/services/PermisosService";
import {faClose, faEdit, faPlus, faSearch, faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import AdminPermisosFormComponent from "@/views/adminPermisosForm-Component.vue";

export default {
  components: {
    AdminPermisosFormComponent,
    FontAwesomeIcon
  },
  inject: ['$axios', '$localStorageService'],
  setup() {
    return {
      srv_PermisoService: new PermisosService(inject('$axios'))
    }
  },
  props: {},
  data() {
    return {
      filtros: {
        nombre: null
      },
      datos_tabla: [],
      id: null,

      mostrarFormBusqueda: false,
      datosForm: null
    }
  },
  async mounted() {
    await this.obtener();
  },
  methods: {
    faPlus() {
      return faPlus;
    },
    faSearch() {
      return faSearch;
    },
    faClose() {
      return faClose;
    },
    faDesActivar() {
      return faTrash;
    },
    faEditar() {
      return faEdit;
    },
    async obtener() {

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      this.datos_tabla = [];
      await this.srv_PermisoService.obtener(this.filtros).then((response) => {
        this.datos_tabla = response;
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    async eliminar(num) {

      const t = this;

      this.$swal({
        title: "Confirmación de eliminación!",
        text: "¿Deseas eliminar permanentemente éste registro?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Si (Elimínalo)',
        denyButtonText: 'No (Cancelar)',
      }).then(async function(result) {
        if (result.isConfirmed) {
          let load = t.$loading.show({
            container: t.$refs.formContainer,//puede ponerse null
            canCancel: false,
            onCancel: t.onCancelLoader,
          });
          await t.srv_PermisoService.eliminar(num).then(() => {
          }).catch((error) => {
            console.error(error)
            t.$swal(error.message);
          }).finally(() => {
            load.hide();
            t.obtener();
          });
        }
      });
    },
    editar(data) {
      this.mostrarFormBusqueda = true;
      this.datosForm = data;
    },
    cancelarEditar() {
      this.mostrarFormBusqueda = false;
      this.datosForm = null;
      this.obtener();
    },
  }
}
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
}
</style>